"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _trialApi = require("self-service-api/core/api/trialApi");

var _trialStateAdapter = require("self-service-api/adapters/trialStateAdapter");

var getTrialState = function getTrialState() {
  return _trialApi.TrialsApi.getTrialState().then(function (trialState) {
    return (0, _trialStateAdapter.trialStateAdapter)(trialState);
  });
};

var _default = getTrialState;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/api/getTrialState.js
// module id = 763
// module chunks = 5 6